import { Pipe, PipeTransform } from '@angular/core';
import { formatClaimType } from '../_helpers/enum-label.helper';
import { ClaimType } from '../enum/claimtype.enum';

@Pipe({
    name: 'claimTypeLabel',
    standalone: false
})
export class ClaimTypeLabelPipe implements PipeTransform {
  transform(value: ClaimType | number | null | undefined): string {
    return formatClaimType(value);
  }
}